import StatusOnline from '@components/StatusOnline.vue';
import { createApp } from 'vue';

export const initStatusOnline = () => {
  if (!document.getElementById('primary-contact-status-app')) {
    return;
  }

  createApp(StatusOnline)
    .mount('#primary-contact-status-app');
};
